import { UserLocation } from "../../models/User";

export const UPDATE_USER_LOCATION = "UPDATE_USER_LOCATION";

export interface UpdateUserLocation {
  type: typeof UPDATE_USER_LOCATION;
  payload: UserLocation;
}

export interface UserLocationState {
  currentLocation: UserLocation;
}

export type UserLocationActionTypes = UpdateUserLocation;
